/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The "create manual lead" screen — staff enter a vehicle + customer + lead
 * intake directly (no source plan detail) and the form submits a manual lead.
 */

import { ManualLeadForm } from '@euler/app/flows/leads/pages/create-manual-lead/components/ManualLeadForm';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const CreateManualLeadScreen = wrapNavigatorScreen(
  () => <ManualLeadForm />,
  { title: '新建商机' },
);
